module.exports = __webpack_public_path__ + "static/media/goblins_background.0c1aea8c.png";